<template>
    <div class="header">
        <div class="logo-img-header">
            <router-link :to="{ path: '/' + (getSelectedLanguage.code == null ? 'bs' : getSelectedLanguage.code) }">
                <img src="../../assets/FIA_plavi_znak.png"></router-link>
        </div>
        <div class="header-menus" :class="{ showMenu: isMenuOpen }" id="header-menus">
            <app-main-menu></app-main-menu>
            <div class="header-menu-search" id="header-menu-search">
                <div class="secondary-menu">
                    <app-profile-menu v-if="getAuth.isUserAuthenticated"
                        class="profile-or-login-btn-new"></app-profile-menu>
                    <a :href="identityUrl" v-else class="profile-or-login-btn-new" :title="$t('logIn')">{{
                        $t("logIn")}}</a>
                    <app-language-switcher></app-language-switcher>
                </div>
                <div>
                    <div class="search-container">
                        <i class="fa fa-search search-icon"></i>
                        <input class="search search-input-font" v-bind:placeholder="$t('startSearching')"
                            v-model="getSearch.params.text" v-on:keyup.enter="initSearch" />
                    </div>
                </div>
            </div>
        </div>
        <button class="hamburger" @click="toggleMenu">
            <i class="menuIcon fa fa-bars" v-if="!isMenuOpen"></i>
            <i class="closeIcon" v-else>X</i>
        </button>
    </div>
</template>

<script>
import MainMenu from "../menu/MainMenuNew.vue"
import LanguageSwitcher from "./LanguageSwitcher.vue"
import ProfileMenu from "./ProfileMenu.vue"
import { mapGetters } from "vuex"

export default {
    data() {
        return {
            isMenuOpen: false
        }
    },
    methods: {
        initSearch() {
            var tag = this.getSearch.params.tag;
            var topic = this.getSearch.params.text;

            var route = { name: 'search', query: { topic: topic, tagId: (tag ? tag.tagId : null) } };

            if (this.$route.name != route.name || this.$route.query.topic != route.query.topic) {
                this.$router.push(route);
                this.closeMenu();
            }

        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        closeMenu() {
            this.isMenuOpen = false;
        }
    },
    computed: {
        ...mapGetters(["getSelectedLanguage", "getSearch", "getAuth"]),
        identityUrl() {
            return `https://identity.fia.ba?redirectTo=${encodeURIComponent(window.location.origin) + encodeURIComponent(this.$route.fullPath)}`;
        }
    },
    filters: {
        upperCase(val) {
            return val.toUpperCase();
        }
    },
    components: {
        appMainMenu: MainMenu,
        appLanguageSwitcher: LanguageSwitcher,
        appProfileMenu: ProfileMenu
    },
    watch: {
        '$route': function (to, from) {
            if (this.isMenuOpen) {
                this.closeMenu();
            }
        }
    },
    mounted() {
        this.$router.afterEach(() => {
            if (this.isMenuOpen) {
                this.closeMenu();
            }
        });
    }
}
</script>

<style scoped>
.header {
    padding: 1% 7% 1% 7%;
    display: flex;
    background-color: var(--light-color);
    position: relative;
    width: 100%;
    box-shadow: -1px -2px 8px -5px var(--main-color);
}

.hamburger {
    display: none;
}

.header-menus {
    /* width: 80%; */
    width: calc(100% - 220px);
    display: flex;
    /* letter-spacing: -1px; */
    word-spacing: -2px;
}

.logo-img-header {
    /* width: 20%; */
    max-width: 260px;
}

.logo-img-header img {
    /* width: 100%;
    height: 90%;*/
    width: 100%;
    height: auto;
} 

.header-menu-search {
    display: flex;
    justify-content: flex-end;
    /* padding-top: 55px; */
    padding-top: 30px;
    width: 45%;
    gap: 20px;
    align-items: end;
}

.secondary-menu {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    color: var(--main-color);
    width: 50%;
    /* align-items: start; */
    align-items: end;
    text-align: right;
}

.profile-or-login-btn-new {
    text-decoration: none;
    color: var(--main-color);
    /* font-size: 24px; */
    font-size: 1.3rem;
    line-height: 1.4rem;
    font-weight: 400;
}

.main-menu a:hover,
.profile-or-login-btn-new:hover {
    text-decoration: none;
    color: rgba(87, 111, 188, 1);
    cursor: pointer;

}

.search-container {
    position: relative;
    width: 100%;
    display: flex;
}

.search {
    width: 100%;
    padding: 5px 40px 5px 50px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    background-color:  var(--secondary-color);
    color: var(--main-color);
    font-size: .95rem;
}

.search::placeholder {
    /* color: #f68000; */
    color: #465481;
    opacity: 1;
}

.search:focus {
    outline: none;
}

.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: rgb(122, 119, 119);
}


@media only screen and (max-width: 1400px) {
    .header {
        display: block;
        padding-bottom: 0%;
    }

    .logo-img-header {
        width: 30%;
    }

    .header-menus {
        display: flex;
        width: 100%;
    }

    .main-menu {
        width: 50%;
        padding: 2% 0% 2% 0%;
    }

    .header-menu-search {
        width: 50%;
        padding-top: 2%;
        padding-bottom: 2%;
        align-items: start;
        gap: 15px;
    }

    .secondary-menu{
        gap: 15px;
    }
}

@media only screen and (max-width: 992px) {
    .header {
        padding-bottom: 2%;
        justify-content: space-between;
    }

    .logo-img-header {
        width: 35%;
    }

    .header-menus {
        display: block;
        height: 40%;
    }

    .main-menu,
    .header-menu-search {
        display: flex;
        flex-direction: column;
        margin: 0% 5% 2% 5%;
        text-decoration: none;
        text-align: left;
        padding: 0;
        font-size: 1.3rem;
        line-height: 1.4rem;
        width: 90%;
    }
    
    .main-menu{
        gap: 5px;
        margin-bottom: 20px;
    }

    .header-menu-search{
        width: 90%;
    }

    .secondary-menu {
        flex-direction: column;
        padding: 0 !important;
        /* font-size: 25px;
        line-height: 40px; */
        color: var(--main-color);
        margin-bottom: 20px;
        align-items: start;
        text-align: left;
        gap: 5px;
    }

    .secondary-menu-item-lng,
    .secondary-menu-item {
        text-align: left;
    }

    .hamburger {
        display: flex;
        position: absolute;
        z-index: 100;
        top: 20%;
        right: 7%;
        padding: 4px;
        border: none;
        background-color: transparent;
        cursor: pointer;
    }

    .hamburger i {
        font-size: 25px;
        color: var(--main-color);
        /* position: fixed; */
        right: 20px;
    }

    .closeIcon {
        /* display: none; */
        font-style: normal;
        position: fixed;
    }

    .header-menus {
        position: fixed;
        transform: translateY(-100%);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        background: radial-gradient(#BDCDFB,  var(--secondary-color));
        list-style: none;
        padding-top: 4rem;
    }

    .showMenu {
        transform: translateY(0);
    }
}

@media only screen and (max-width: 768px) {
    .logo-img-header {
        width: 50%;
    }

}
</style>
